import {
  IonBadge,
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonLoading,
  IonMenuButton,
  IonPage,
  IonText,
  IonTitle,
  IonToolbar,
  useIonViewWillEnter,
} from "@ionic/react";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router";
// import "../../components/ExploreContainer.css";
import {
  Box,
  Divider,
  InputLabel,
  MenuItem,
  TextField,
  FormControl,
  Autocomplete,
  Button,
  Typography,
  Alert,
  AlertTitle,
  Stack,
  Card,
  CardContent,
  Grid,
  InputAdornment,
  Paper,
} from "@mui/material";
import { PhotoCamera, BorderColor } from "@mui/icons-material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
//   import { baseUrl, requestID } from "../../common/utils";
import CircularProgress from "@mui/material/CircularProgress";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { requestID, baseUrl, getAppSettings, config } from "../common/utils";
import { formatCurrencyN } from "../common/utils_t";

const MainDashboard_xmas = () => {
  // const navigate = useNavigate()
 
  const [isOpen, setIsOpen] = useState(false);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [errorLogin, setErrorLogin] = useState("");
  const [showToast, setShowToast] = useState(false);
 
 
 
 

  var today = new Date();
  var year = today.getFullYear();
  var month = String(today.getMonth() + 1).padStart(2, "0"); // January is 0, so we add 1
  var day = String(today.getDate()).padStart(2, "0");
  var formattedDate = `${year}-${month}-${day}`;

 
  const [orderDetails, setOrderDetails] = useState(null);
 // const [status, setStatus] = useState({ loading: false, error: false });
  const [error, setError] = useState("");
 
  const [dashBoardData, setDashBoardData] = useState({});

  // const { siteName } = getAppSettings();


  const getDashboardInfo = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    // formData.append("shopID", id);
    setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgers/getDashboardInfo", formData, config)
      .then((response) => {
       console.log(response);
        console.log(response.data);

        setDashBoardData(response.data);

        setStatus({ loading: false, error: false });
      })
      .catch((error) => {
        setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

  const getDashboardInfo1 = () => {
    const formData = new FormData();
    formData.append("requestID", requestID());
    // formData.append("shopID", id);
    //setStatus({ loading: true, error: false });
    axios
      .post(baseUrl() + "ledgers/getDashboardInfo", formData, config)
      .then((response) => {
       console.log(response);
       // console.log(response.data);

        setDashBoardData(response.data);

      // setStatus({ loading: false, error: false });
      })
      .catch((error) => {
     //   setStatus({ loading: false, error: false });
        // throw new error("hey ");
      });
  };

//setInterval(()=>getDashboardInfo1(), 300000);


  useEffect(() => {
    return () => {};
  }, []);


  useIonViewWillEnter(()=>{

    getDashboardInfo();

  })
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          {/* <IonTitle>{siteName}</IonTitle>  */}


          <IonText className="dashDate" slot="end"> Xams - Today Date: 23-04-2024</IonText>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"></IonTitle>
          </IonToolbar>
        </IonHeader>

        <Box
          sx={{
            display: "flex",
            margin: "2%",
            flexWrap: "wrap",

            "& > :not(style)": {
              m: 1,
             
            },
          }}
        >
          <IonCard className="embossed-card dbCard1 totalMember" >
            <IonCardHeader>
              <IonCardSubtitle className="brightText">Total Members</IonCardSubtitle>

              <IonCardTitle className="dashFigure2">#{dashBoardData?.totalMember} </IonCardTitle>
            </IonCardHeader>


            <IonCardSubtitle className="brightText">Total Share Capital</IonCardSubtitle>
            <IonCardTitle className="dashFigure2">{dashBoardData?.totalCapitalsAmt_raw}</IonCardTitle>
          </IonCard>{" "}


          <IonCard className="embossed-card dbCard6 totalSaving" color="">
            <IonCardHeader>
              <IonCardSubtitle className="brightText">Total Saving</IonCardSubtitle>

              <IonCardTitle className="dashFigure1">
                
                
                {((dashBoardData?.totalSavingsAmt_raw))} </IonCardTitle>
            </IonCardHeader>
          </IonCard>{" "}

        


          <IonCard className="embossed-card dbCard2 activeLoan1" >
            <IonCardHeader>
              <IonCardSubtitle className="brightText">No. Of Active Loans</IonCardSubtitle>

              <IonCardTitle className="dashFigure1">#{dashBoardData?.totalLoan} </IonCardTitle>
            </IonCardHeader>
          </IonCard>{" "}





        </Box>

          <Box
          sx={{
            display: "flex",
            margin: "2%",
            flexWrap: "wrap",

            "& > :not(style)": {
              m: 1,
             
            },
          }}
        >
        
        <IonCard className="embossed-card dbCard3 outstandLoan"  >
            <IonCardHeader>
              <IonCardSubtitle className="brightText"> Outstanding Loans</IonCardSubtitle>

              <IonCardTitle className="dashFigure1">{dashBoardData?.outStandingLoan_raw} </IonCardTitle>
            </IonCardHeader>
          </IonCard>{" "}
          <IonCard className="embossed-card dbCard4" color="secondary">
            <IonCardHeader>
              <IonCardSubtitle>UniFied Wallet</IonCardSubtitle>

              <IonCardTitle className="dashFigure">{dashBoardData?.unifiedLedgerBal_raw} </IonCardTitle>
            </IonCardHeader>
          </IonCard>{" "}


          <IonCard className="embossed-card dbCard5" color="danger">
            <IonCardHeader>
              <IonCardSubtitle> Pending Approval(s)</IonCardSubtitle>

              <IonCardTitle className="dashFigure">#{dashBoardData?.totalApproval} </IonCardTitle>
            </IonCardHeader>
          </IonCard>{" "}



      


     
        </Box>


        <IonList className="DashList">
      <IonItem>
        <IonLabel>Total Cash-withdrawal Request</IonLabel>
        <IonBadge color="primary">{dashBoardData?.totalCashWithdrawal}</IonBadge>
      </IonItem>
      <IonItem>
        <IonLabel>Total Membership-Withrawal Request</IonLabel>
        <IonBadge color="secondary">{dashBoardData?.totalMemberWithdrawal}</IonBadge>
      </IonItem>
      {/* <IonItem>
        <IonLabel>Bank Balance</IonLabel>
        <IonBadge color="tertiary">34k</IonBadge>
      </IonItem> */}
   
   
      <IonItem>
        <IonLabel> Unapproved Loans Waiting for Loan Commitee </IonLabel>
        <IonBadge color="danger">{dashBoardData?.totalUnApprovedLoans}</IonBadge>
      </IonItem>
    </IonList>
      </IonContent>
      <IonLoading
          message="Please Wait..."
          spinner="circles"
          isOpen={status.loading}
        />    </IonPage>
  );
};

export default MainDashboard_xmas;
